var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8 56.9c0-5-2.2-9.5-5.7-12.5v-1c0-9.7-3.8-19.7-10.4-27.5C71.7 7.6 62.6 3 53.2 3h-6.5C26.1 3 10.8 24.3 10.8 43.4v.9C7.2 47.4 5 51.9 5 56.9c0 7.2 4.6 13.5 11.4 15.7 1.6 3.4 5.1 5.7 9.1 5.7 5.5 0 10-4.5 10-10V46.1c0-5.5-4.5-10-10-10-3.7 0-7 2-8.7 5.1-.7.2-1.4.5-2.1.8.7-16.7 14.4-35.2 32-35.2h6.5c17.5 0 31.3 18.5 32.1 35.1-.8-.4-1.7-.7-2.7-1-1.8-2.9-5-4.9-8.6-4.9-5.5 0-10 4.5-10 10v22.3c0 5 3.6 9.1 8.4 9.9v5c0 3.9-3.2 7.1-7.1 7.1h-7.1c-1.1-2.3-4.2-3.9-8-3.9-4.7 0-8.4 2.6-8.4 5.8 0 3.3 3.7 5.8 8.4 5.8 3.8 0 6.9-1.6 8-3.9h7.1c6 0 10.9-4.9 10.9-10.9v-5.1c3-.7 5.5-2.7 6.8-5.3 6.9-2.1 11.8-8.5 11.8-15.9zM25.5 39.8c3.4 0 6.2 2.8 6.2 6.2v22.3c0 3.4-2.8 6.2-6.2 6.2-3.4 0-6.2-2.8-6.2-6.2V46.1c-.1-3.5 2.7-6.3 6.2-6.3zm-10.1 6.3v22c-4-2.2-6.6-6.5-6.6-11.2 0-4.8 2.6-9 6.6-11.2v.4zm34.7 48.1c-2.9 0-4.6-1.3-4.6-2s1.8-2 4.6-2c2.9 0 4.6 1.3 4.6 2 .1.7-1.7 2-4.6 2zM74 74.6c-3.4 0-6.2-2.8-6.2-6.2V46.1c0-3.4 2.8-6.2 6.2-6.2 3.4 0 6.2 2.8 6.2 6.2v22.3c0 3.4-2.8 6.2-6.2 6.2zm10-6.3V45.5c4.2 2.1 7 6.5 7 11.4s-2.8 9.3-7 11.4z",
    fill: "#5C5C5C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/customer-support.3f23d368be79710fb402f9dbe4f3a861.svg";
export { ForwardRef as ReactComponent };